import { DischargedService } from '@/services/discharged.service';

export const isDischargedCheck = async (): Promise<boolean> => {
  const dischargedService = new DischargedService();
  const dischargeStatus = await dischargedService.get();

  return dischargeStatus === 1;
};
